// import { useState, useEffect, useContext } from "react";
// import "./common.scss";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import dayjs from "dayjs";

// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import FormRendererContext from "../../services/context/FormRendererContext";

// const DateInput = ({ data, setAnswer, formValidation = true, formClass }) => {
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [validForm, setFormValidation] = useState(formValidation);
//   const { answerData } = useContext(FormRendererContext);

//   useEffect(() => {
//     setFormValidation(formValidation);
//     if (data?.answer && data.answer?.value !== "") {
//       if (
//         data.answer?.value &&
//         typeof data.answer.value === "object" &&
//         data.answer?.value?.$isDayjsObject
//       ) {
//         setSelectedOption(dayjs(data.answer?.value?.$d));
//         setFormValidation(true);
//       } else {
//         setSelectedOption(data.answer?.value);
//         setFormValidation(true);
//       }
//     }
//     if (answerData?.[data?.key]) {
//       if (
//         answerData?.[data?.key]?.value &&
//         typeof answerData?.[data?.key].value === "object" &&
//         answerData?.[data?.key]?.value?.$isDayjsObject
//       ) {
//         setSelectedOption(dayjs(answerData?.[data?.key]?.value?.$d));
//         setFormValidation(true);
//       } else {
//         setSelectedOption(data.answer?.value);
//         setFormValidation(true);
//       }
//       // setSelectedOption(answerData?.[data?.key]?.value);
//     }
//   }, [data, formValidation]);

//   const handleDateChange = (date) => {
//     console.log("date", date);
//     setSelectedOption(date);
//     setAnswer(data, { value: date });
//     date && setFormValidation(true);
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <div className={`w-full ${formClass}`}>
//         <div className="form-title pt-3">
//           {data.label}
//           {data?.validate?.required ? (
//             <span className={!validForm ? "text-red-700" : "text-gray-600"}>
//               {" "}
//               *
//             </span>
//           ) : (
//             <></>
//           )}
//         </div>
//         <form className="flex-grow">
//           <div className="radio-common date-picker my-2">
//             <DatePicker
//               // label="Controlled field"
//               disableFuture={data?.maxDate === "today"}
//               value={selectedOption}
//               onChange={(newValue) => {
//                 handleDateChange(newValue);
//               }}
//               className="text-field text-input"
//             />

//             {/* <input
//               type="date"
//               value={selectedOption}

//               pattern="\d{4}-\d{2}-\d{2}"
//               onChange={(e) => {
//                 setSelectedOption(e.target.value);
//                 setAnswer(data, {value: e.target.value});
//                 setFormValidation(true);
//               }}
//               className="text-field text-input"
//             /> */}
//           </div>
//         </form>
//         {data?.validate?.required && !validForm ? (
//           <span className="text-red-700 font-light text-xs">
//             {data?.invalidMessage || "Required Field"}
//           </span>
//         ) : (
//           <></>
//         )}
//       </div>
//     </LocalizationProvider>
//   );
// };
// export default DateInput;

import { useState, useEffect, useContext } from "react";
import "./common.scss";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FormRendererContext from "../../services/context/FormRendererContext";

const DateInput = ({ data, setAnswer, formValidation = true, formClass }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [validForm, setFormValidation] = useState(formValidation);
  const { answerData, isJourneyReadOnly } = useContext(FormRendererContext);

  // Check if this is a DOB field
  const isDOB = data?.type === "dob";

  // Helper function to safely parse date values
  const parseDateValue = (value) => {
    if (!value) return null;

    // For DOB single input format (YYYY-MM-DD or MM/DD/YYYY)
    if (typeof value === "string") {
      const parsed = dayjs(value);
      return parsed.isValid() ? parsed : null;
    }

    // If it's already a dayjs object
    if (typeof value === "object" && value?.$isDayjsObject) {
      return dayjs(value.$d);
    }

    // If it's already a dayjs object
    if (typeof value === "object" && value?.raw) {
      if (value.raw?.$isDayjsObject) return dayjs(value.raw?.$d);
      if (value?.dateObj && value?.dateObj instanceof Date) {
        const parsed = dayjs(value?.dateObj);
        return parsed.isValid() ? parsed : null;
      }
      return null;
    }

    // If it's a number or Date instance, try to parse it
    if (typeof value === "number" || value instanceof Date) {
      const parsed = dayjs(value);
      return parsed.isValid() ? parsed : null;
    }

    return null;
  };

  // Helper function to format date in US format (MM/DD/YYYY)
  const formatToUSDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  // Helper function to format time in US format (12-hour with AM/PM)
  const formatToUSTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const createDateObject = (
    dateTimeValue,
    field = {
      type: "date", // default to date, can be overridden
    }
  ) => {
    if (!dateTimeValue) return null;

    try {
      let dateObj;
      let isoString;

      if (field.type === "date" || isDOB) {
        // For date only or DOB, create date object
        dateObj = new Date(dateTimeValue);
        isoString = dateObj.toISOString();
      } else {
        // For datetime
        dateObj = new Date(dateTimeValue);
        isoString = dateObj.toISOString();
      }

      return {
        date: formatToUSDate(isoString),
        time: field.type === "dateTime" ? formatToUSTime(isoString) : null,
        dateObj: dateObj,
        isoString: isoString,
        timestamp: dateObj.getTime(),
        year: dateObj.getFullYear(),
        month: dateObj.getMonth() + 1,
        day: dateObj.getDate(),
        hour: field.type === "dateTime" ? dateObj.getHours() : null,
        minute: field.type === "dateTime" ? dateObj.getMinutes() : null,
        dayOfWeek: dateObj.toLocaleDateString("en-US", { weekday: "long" }),
        monthName: dateObj.toLocaleDateString("en-US", { month: "long" }),
        formattedDateTime:
          field.type === "dateTime"
            ? dateObj.toLocaleDateString("en-US") +
              " " +
              dateObj.toLocaleTimeString("en-US", { hour12: true })
            : dateObj.toLocaleDateString("en-US"),
        raw: dateTimeValue,
      };
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    setFormValidation(formValidation);

    // Check answerData first (it takes precedence)
    if (answerData?.[data?.key]?.value) {
      const parsedDate = parseDateValue(answerData[data.key].value);
      if (parsedDate) {
        setSelectedOption(parsedDate);
        setFormValidation(true);
      } else {
        console.warn("Invalid date in answerData:", answerData[data.key].value);
        setSelectedOption(null);
      }
    }
    // Fallback to data.answer
    else if (data?.answer?.value && data.answer.value !== "") {
      const parsedDate = parseDateValue(data.answer.value);
      if (parsedDate) {
        setSelectedOption(parsedDate);
        setFormValidation(true);
      } else {
        console.warn("Invalid date in data.answer:", data.answer.value);
        setSelectedOption(null);
      }
    } 
  }, [data, formValidation, answerData]);

  const handleDateChange = (date) => {
    if (!date) {
      setSelectedOption(null);
      setAnswer(data, { value: null });
      setFormValidation(false);
      return;
    }

    if (!dayjs(date).isValid()) {
      setSelectedOption(date);
      setAnswer(data, { value: null });
      setFormValidation(false);
      return;
    }

    setSelectedOption(date);

    // For DOB fields, return simple string format
    if (isDOB) {
      const dateObj = new Date(date);
      const formattedString = dateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      setAnswer(data, { value: formattedString });
      setFormValidation(true);
      return;
    }

    // For other date fields, check outputFormat
    const outputFormat = data?.outputFormat?.toLowerCase();
    if (outputFormat === "string") {
      const dateObj = new Date(date);
      const formattedString = dateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      setAnswer(data, { value: formattedString });
    } else {
      const createdDate = createDateObject(date, data);
      setAnswer(data, { value: createdDate });
    }

    setFormValidation(true);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className={`w-full ${formClass}`}>
        {!data?.hideLabel && (
          <div className="form-title pt-3">
            {data.label}
            {data?.validate?.required ? (
              <span className={!validForm ? "text-red-700" : "text-gray-600"}>
                {" "}
                *
              </span>
            ) : (
              <></>
            )}
          </div>
        )}
        <form className="flex-grow">
          <div className="radio-common date-picker my-2">
            <DatePicker
              disabled={data?.disabled || isJourneyReadOnly || false}
              disableFuture={data?.maxDate === "today"}
              value={selectedOption}
              views={["year", "month", "day"]}
              onChange={(newValue) => {
                handleDateChange(newValue);
              }}
              className="text-field text-input"
              // Add maxDate for DOB to prevent future dates
              {...(isDOB && { maxDate: dayjs() })}
              // Add reasonable minDate for DOB (e.g., 150 years ago)
              {...(isDOB && { minDate: dayjs().subtract(150, "year") })}
            />
          </div>
        </form>
        {data?.validate?.required && !validForm ? (
          <span className="text-red-700 font-light text-xs">
            {data?.invalidMessage || "Required Field"}
          </span>
        ) : (
          <></>
        )}
      </div>
    </LocalizationProvider>
  );
};

export default DateInput;
